import { combineReducers, configureStore } from '@reduxjs/toolkit';
import appSlice from '@/redux/appSlice';
import storage from 'redux-persist/lib/storage/session';
import { encryptTransform } from 'redux-persist-transform-encrypt';
import { persistReducer, persistStore } from 'redux-persist';

const encryptor = encryptTransform({
  secretKey: 'hVmYq3t6w9y$B&E)H@McQfTjWnZr4u7x',
  onError: function (error) {
    console.log('encryptor error', error);
  },
});

const rootPersistConfig = {
  key: 'root',
  storage,
  whitelist: [],
  transforms: [encryptor],
};

const appPersistConfig = {
  key: 'app',
  storage,
  whitelist: ['tariffPageLoading', 'userInformation', 'couponCodeSuccess'],
  transforms: [encryptor],
};

const reducers = combineReducers({
  app: persistReducer(appPersistConfig, appSlice),
});

const persistedReducer = persistReducer(rootPersistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  //middleware: [thunkMiddleware]
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
